import { Component, inject, input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MtrInputModule } from '@mortar/angular/components/atomic/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from 'app/driver-pay/persistence/core/components/inputs/InputComponent';
import { EnumContextDirective } from 'app/driver-pay/persistence/core/components/displays/EnumDisplay.component';
import { MtrSelectModule } from '@mortar/angular/components/atomic/select';

@Component({
  selector: 'enum-input',
  standalone: true,
  template: `
    <mtr-form-field hideLabel>
      <mtr-select
        id="{{ id() }}"
        [formControl]="inputFormControl()"
        placeholder="Select..."
        [options]="enumContext.options" />
    </mtr-form-field>
  `,
  imports: [MtrFormFieldModule, MtrInputModule, FormsModule, ReactiveFormsModule, MtrSelectModule],
})
export class EnumInputComponent implements InputComponent, AfterViewInit {
  inputFormControl = input.required<FormControl<string> | FormControl<string | null>>();
  id = input.required<string>();
  enumContext = inject(EnumContextDirective);
  private readonly cdr = inject(ChangeDetectorRef);

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
}
